import { createContext, type Context } from 'react';

/**
 * __Is Ribbon enabled context__
 *
 * Tracks if Ribbon is enabled.
 * Defaults to false
 */
export const IsRibbonEnabledContext: Context<boolean> = createContext<boolean>(false);
